export const selectHintModalData = (state) => state.modal.hintModalData

export const selectGlobalModalData = (state) => state.modal.globalModalData
